
@if (demo.isActive) {
<div class="row mb-5">

    <div class="col-8 d-flex">
        <div class="card flex-grow-1 mb-0">
            <div class="card-body d-flex flex-column">
                <p class="small fw-bold mb-3 oneline">{{ texts.outreach.contacted | localize }}</p>
                <div class="outreach-chart">
                    <canvas #outreachChart class="chart-canvas"></canvas>
                    <!-- pinned to the target line by the chart, see targetBadgePlugin -->
                    <span #targetBadge class="badge badge-pill badge-success target-badge">
                        <i class="fa-sharp fa-solid fa-bullseye me-2"></i>{{ texts.outreach.target | localize }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="col-4">
        <app-kpi-card class="h-auto mb-3" [label]="texts.outreach.totalContacted | localize">
            {{ outreachKpis.contacted | number }}
        </app-kpi-card>
        <app-kpi-card class="h-auto mb-3" [label]="texts.outreach.clicks | localize">
            {{ outreachKpis.clicks / outreachKpis.contacted * 100 | number : '0.1-1' }}%
        </app-kpi-card>
        <app-kpi-card class="h-auto" [label]="texts.outreach.applications | localize">
            {{ outreachKpis.applications / outreachKpis.contacted * 100 | number : '0.1-1' }}%
        </app-kpi-card>
    </div>

</div>

<div class="card mt-4">
    <div class="card-header">
        <h5 class="card-title">{{ texts.feedback.title | localize }}</h5>
    </div>
    <div class="card-body">

        <div class="row">
            <div class="col-12">
                <div class="alert alert-primary mb-5 border">
                    <div class="row">
                        <div class="col-auto pe-0">
                            <i class="fa-sharp fa-solid fa-stars text-primary"></i>
                        </div>
                        <div class="col">
                            <p class="mb-0">{{ feedbackSummary }}</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-5">

                <ul class="list-group list-group">
                    <li class="list-group-item">
                        <p class="h5 fw-bold mb-0">{{ texts.feedback.rejectReasons | localize }}</p>
                    </li>
                    @for (r of rejectReasons; track r.Key)
                    {
                    <li class="list-group-item py-2">
                        <div class="row align-items-center">
                            <div class="col">
                                <p class="mb-0 fw-normal">{{ texts.feedback.reasons[r.Key] | localize }}</p>
                            </div>
                            <div class="col-auto text-end">
                                <p class="fw-bold mb-0">{{ r.Share | number : '0.0-0' }}%</p>
                            </div>
                            <div class="col-auto ps-0">
                                @if (r.Benchmark == 'better') {
                                <i class="fa-sharp fa-regular fa-arrow-up text-success"></i>
                                } @else if (r.Benchmark == 'worse') {
                                <i class="fa-sharp fa-regular fa-arrow-down text-danger"></i>
                                } @else {
                                <i class="fa-sharp fa-regular fa-arrow-up invisible"></i>
                                }
                            </div>
                        </div>
                    </li>
                    }
                </ul>
            </div>

            <div class="col-7">
                <ul class="list-group list-group fw-normal">
                    <li class="list-group-item">
                        <p class="h5 fw-bold mb-0">{{ texts.feedback.messages | localize }}</p>
                    </li>
                    @for (m of feedbackMessages; track m)
                    {
                    <li class="list-group-item">
                        <p class="mb-1 small">„{{ m.Text }}“</p>
                        <span class="small text-muted">{{ texts.feedback.reasons[m.Reason] | localize }}</span>
                    </li>
                    }
                </ul>
            </div>

        </div>
    </div>
</div>
}

@else
{

@if (project.Status == 'Sourcing' || project.Status == 'AwaitingSourcing')
{
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col">
                        <p class="mb-0 text-muted">
                            <i class="fa-sharp fa-solid fa-circle-info me-2"></i> Das Projekt läuft! Du wirst
                            benachrichtigt, wenn Bewerbungen eintreffen.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}

@if (project.Status == 'Imported' || project.Status == 'AnalysisRequested' || project.Status == 'AwaitingOrder')
{
<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div class="row align-items-center">
                    <div class="col">
                        <p class="mb-0 text-muted">
                            <i class="fa-sharp fa-solid fa-circle-info me-2"></i> {{ texts.noCandidates | localize }}
                        </p>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-dark" (click)="startModal.show(project)">Starten <i
                                class="fa-sharp fa-solid fa-arrow-right ms-2"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-modal-start-project #startModal [language]="loc.language"></app-modal-start-project>
}
}